<template>
  <div class="columns is-multiline">
    <div class="column is-12 has-text-left" style="padding-bottom: 0">
      <nav-bar></nav-bar>
    </div>
    <div class="column is-12" style="padding-right: 20px">
      <div class="section">
        <div class="container has-text-left">
          <h1 class="title">{{ $store.state.selectedViewTitle }}</h1>
        </div>
      </div>
      <div class="section">
        <div class="container">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar";
import { mapMutations } from "vuex";

export default {
  name: "AppContainer",
  components: { NavBar },
  methods:{
    ...mapMutations({loadLoggedUser: "loadLoggedUser" })
  },
  created() {
    this.loadLoggedUser();
  }
};
</script>

<style lang="scss" scoped></style>
